import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const At = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C13.8 22 15.5 21.5 17 20.7C17.5 20.4 17.6 19.8 17.4 19.3C17.1 18.8 16.5 18.7 16 18.9C12.2 21.1 7.3 19.8 5.1 16C2.9 12.2 4.2 7.3 8 5.1C11.8 2.9 16.7 4.2 18.9 8C19.6 9.2 20 10.6 20 12V12.8C20 13.8 19.2 14.6 18.2 14.6C17.2 14.6 16.4 13.8 16.4 12.8V8.5C16.4 7.9 16 7.5 15.4 7.5C14.9 7.5 14.5 7.8 14.4 8.3C12.4 6.9 9.5 7.4 8.1 9.4C6.7 11.4 7.2 14.3 9.2 15.7C11.1 17 13.6 16.7 15.1 15C16.4 16.6 18.7 16.9 20.3 15.7C21.2 15 21.8 13.9 21.8 12.7V12C22 6.5 17.5 2 12 2ZM12 14.5C10.6 14.5 9.5 13.4 9.5 12C9.5 10.6 10.6 9.5 12 9.5C13.4 9.5 14.5 10.6 14.5 12C14.5 13.4 13.4 14.5 12 14.5Z"
      fill="currentColor"
    />
  </svg>
)

export default At
